import { UserService } from "@main-services/user.service";
import { Injectable } from "@angular/core";
import { VERIFICATION_MODAL_ROUTE } from "@helpers/constants";
import { Router } from "@angular/router";
import { VerificationModalFacade } from "@modules/verification/modal/state/verification-modal.facade";

@Injectable({ providedIn: "root" })
export class UserVerificationBridgeService {
	public constructor(
		private readonly userService: UserService,
		private verificationModalFacade: VerificationModalFacade,
		private readonly router: Router
	) {}

	public isVerificationPending(): boolean {
		return this.userService.isVerificationPending();
	}

	public isVerified(): boolean {
		return this.userService.isVerified;
	}

	public openVerificationPageOrModal(): void {
		if (!this.verificationModalFacade.openVerification()) {
			this.router.navigate(VERIFICATION_MODAL_ROUTE, {
				skipLocationChange: true
			});
		}
	}
}
